import React from "react";
import { useParams } from "react-router";
import ReferenceTables2020 from "./ReferenceTables2020";
import ReferenceTables2021 from "./ReferenceTables2021";
import ReferenceTables2022 from "./ReferenceTables2022";
import ReferenceTables2023 from "./ReferenceTables2023";
import ReferenceTables2024 from "./ReferenceTables2024";
import ReferenceTables2025 from "./ReferenceTables2025";
import ReferenceTables2026 from "./ReferenceTables2026";


const ReferenceTables = () => {
  const { year } = useParams();
  if (year === "2020") {
    return <ReferenceTables2020 />;
  } else if (year === "2021") {
    return <ReferenceTables2021 />;
  } else if (year === "2022") {
    return <ReferenceTables2022 />;   
  } else if (year === "2023") {
    return <ReferenceTables2023 />;  
  } else if (year === "2024") {
    return <ReferenceTables2024 />;   
  } else if (year === "2025") {
    return <ReferenceTables2025 />;
  } else if (year === "2026") {
    return <ReferenceTables2026 />;                  
  } else {
    return null;
  }
};

export default ReferenceTables;
